import { GET } from '@/utils/axios'

export const parseCloudflareTrace = trace =>
  trace
    .trim()
    .split('\n')
    .reduce((obj, line) => {
      const [key, value] = line.split('=')
      if (key) obj[key] = value
      return obj
    }, {})

export const getUserIP = () =>
  GET('https://www.cloudflare.com/cdn-cgi/trace').then(({ data }) => {
    const cloudfareData = parseCloudflareTrace(data)
    window.cloudfareData = cloudfareData
    return cloudfareData
  })
